<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        DateRangePicker(:value="dateRange" @update="getData")
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getLogList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="10%")
                  span(:title="$t('ui.domain')") {{ $t('ui.domain') }}
                th.text-center(width="10%")
                  span(:title="$t('ui.code')") {{ $t('ui.code') }}
                th.text-right(width="10%")
                  span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                th.text-center(width="10%")
                  span(:title="$t('ui.ip_address')") {{ $t('ui.ip_address') }}
                th.text-right(width="15%" @click="sortOrder('action_date')")
                  span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                  .float-right
                    i(:class="changeSortKey('action_date')")
            tbody.clusterize-content
              tr(v-if="logList.length == 0")
                td(colspan="6").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in logList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.domain_name") {{ item.domain_name }}
                td.text-center
                  span.font-weight-bold(:title="item.code") {{ item.code }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                td.text-center
                  span(:title="item.ip_address") {{ item.ip_address }}
                td.text-right
                  span.d-block(:title="item.action_by") {{ item.action_by }}
                  span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    account_id: "",
    dateRange: {
      startDate: null,
      endDate: null
    },
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    logList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "action_date",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberLog;
    }
  },
  mounted: function() {},
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null
    };
    this.$store.dispatch("user/setMemberVoucherRedeemedLogParam", json);
  },
  methods: {
    refresh() {
      if (this.$store.getters.memberVoucherRedeemedLog.start_date && this.$store.getters.memberVoucherRedeemedLog.end_date) {
        this.dateRange.startDate = this.$store.getters.memberVoucherRedeemedLog.start_date;
        this.dateRange.endDate = this.$store.getters.memberVoucherRedeemedLog.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getLogList(true);
    },
    setMemberVoucherRedeemedLogParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setMemberVoucherRedeemedLogParam", json);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      return this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') <= 31;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getLogList(true);
    },
    getLogList: function(isSearch) {
      if (!this.checkDateRange()) {
        this.totalRow = 0;
        this.logList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
        return;
      }

      this.setMemberVoucherRedeemedLogParam();
      let url = config.memberVoucherRedeemedLogUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.memberID,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.logList = response.data.dt;
                this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'membervoucherredeemedlog') return
      this.$store.dispatch("layout/setPageSizeMemberLog", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>